import api from './api';

export async function markQuarterPaid(taxYear, quarter) {
  const res = await api.post('/payments/quarterly/mark', {
    tax_year: taxYear,
    quarter: quarter,
  });
  return res.data;
}

export async function unmarkQuarterPaid(taxYear, quarter) {
  await api.delete(`/payments/quarterly/${taxYear}/${quarter}`);
}

export async function getQuarterlyPayments(taxYear = null) {
  const params = taxYear ? { tax_year: taxYear } : {};
  const res = await api.get('/payments/quarterly', { params });
  return res.data;
}
